import { registerPlugin } from '@capacitor/core';
const ExampleMediaSessionPlugin = registerPlugin('ExampleMediaSessionPlugin', {
    web: () => import('./web').then((m) => new m.ExampleMediaSessionPluginWeb()),
});
export * from './definitions';
export { ExampleMediaSessionPlugin };
//# sourceMappingURL=index.js.map